import React, {useContext, useState} from "react";
import {
    Alert, Box, Button, CircularProgress, Dialog, DialogActions,
    DialogContent, DialogTitle, Stack, TextField
} from "@mui/material";
import {HugeiconsIcon} from "@hugeicons/react";
import {Alert02Icon, CheckIcon, LockIcon, Plug01Icon} from "@hugeicons/core-free-icons";
import {Context} from "../../../../context/AppContext"

const EditTokenModal = ({open, onClose, onSave, server}) => {
    const [newToken, setNewToken] = useState('');
    const [testing, setTesting] = useState(false);
    const [tested, setTested] = useState(false);
    const [testResult, setTestResult] = useState(null);
    const {testMCPConnection} = useContext(Context);

    const handleTest = async () => {
        if (!server.endpoint) return;
        setTesting(true);
        setTestResult(null);
        const data = await testMCPConnection({
            endpoint: server.endpoint,
            auth_token: newToken
        });
        setTestResult(data);
        setTested(data?.ok || false);
        setTesting(false);
    };

    const handleSave = () => {
        onSave(newToken);
        setNewToken('');
        setTestResult(null);
        setTested(false);
        onClose();
    };

    const handleClose = () => {
        setNewToken('');
        setTestResult(null);
        setTested(false);
        onClose();
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth
                PaperProps={{sx: {borderRadius: 3, padding: 1}}}>
            <DialogTitle>
                <Stack direction="row" alignItems="center" gap={1}>
                    <HugeiconsIcon icon={LockIcon} size={18}/>
                    <span>Update Authorization Token</span>
                </Stack>
            </DialogTitle>
            <DialogContent>
                <TextField
                    size="small" label="Authorization token" fullWidth
                    value={newToken}
                    onChange={e => {
                        setNewToken(e.target.value);
                        setTestResult(null);
                        setTested(false);
                    }}
                    type="password"
                    sx={{mt: 1}}
                />
                <Box sx={{mt: 2}}>
                    <Button
                        variant="ghost"
                        disabled={testing || !newToken}
                        startIcon={testing ? <CircularProgress size={14}/> : <HugeiconsIcon icon={Plug01Icon} size={16}/>}
                        onClick={handleTest}
                    >
                        {testing ? "Testing..." : "Test connection"}
                    </Button>

                    {testResult && (
                        <Alert
                            severity={testResult.ok ? "success" : "error"}
                            icon={testResult.ok ? <HugeiconsIcon icon={CheckIcon} size={18}/> : <HugeiconsIcon icon={Alert02Icon} size={18}/>}
                            sx={{borderRadius: 0, fontSize: 13, mt: 1.5}}
                        >
                            {testResult.message}
                            {testResult.ok && testResult.server_name && (
                                <Box component="span" sx={{display: "block", fontSize: 12, opacity: 0.8, mt: 0.5}}>
                                    {testResult.server_name}
                                    {testResult.protocol_version && ` · MCP ${testResult.protocol_version}`}
                                    {testResult.tool_count != null && ` · ${testResult.tool_count} tools`}
                                </Box>
                            )}
                        </Alert>
                    )}
                </Box>
            </DialogContent>
            <DialogActions>
                <Button variant="ghost" onClick={handleClose}>Cancel</Button>
                <Button
                    variant="modal"
                    disabled={!newToken || !tested}
                    onClick={handleSave}
                >
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default EditTokenModal;
